import {InstitutionProfileModel} from '../../shared/models/institutionProfile.model';
import i18n from '../../shared/locales/i18n';

export const getContactName = (profile: InstitutionProfileModel) => {
  if (profile.alias) {
    return `${profile.fullName} (${i18n.t('user.alias')})`
  }
  return profile.fullName;
};
